import { Box, Form, ModBox, Text } from '@jfs/ui-new'
import { entityDetails } from './formData'
const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}
const EntityDetails = () => {
  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40}>
      <Text title={'Entity Details'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
      <ModBox>
        <Form formData={entityDetails()} actionButtons={() => <></>} initialValues={{}} container={FormBox} />
      </ModBox>
    </Box>
  )
}

export { EntityDetails }
